<span [id]="project().id">{{project().name()}}</span>
